import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { RestartSurveyRPC } from "./restartSurveyRPC";

export class RestartSurveyRPCClientImpl extends RestartSurveyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: RestartSurveyRPC.Request): Promise<LeoRPCResult<RestartSurveyRPC.Response, RestartSurveyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-respondent/RestartSurvey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      RestartSurveyRPC.ResponseDTO,
      RestartSurveyRPC.Errors.ErrorsDTO,
      RestartSurveyRPC.Response,
      RestartSurveyRPC.Errors.Errors
    >(
      response,
      "survey-respondent/RestartSurvey",
      RestartSurveyRPC.Response.fromDTO,
      RestartSurveyRPC.Errors.fromDTO
    );
  }
}
